function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,23.813h29.958V6.188H0v17.625Z",
    style: {
      fill: "#003893"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,19.505h29.986v-1.499H0v1.499Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.701h29.997v-3.694H0v3.694Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.005h30v-1.499H0v1.499Z",
    style: {
      fill: "#cf2027"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.509 16.505 6.998 16.151 7.487 16.505 7.3 15.932 7.789 15.578 7.185 15.578 6.998 15.005 6.811 15.578 6.207 15.578 6.696 15.932 6.509 16.505",
    style: {
      fill: "#f7d116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.235 18.578 7.048 18.005 6.861 18.578 6.257 18.578 6.746 18.932 6.559 19.505 7.048 19.151 7.537 19.505 7.35 18.932 7.839 18.578 7.235 18.578",
    style: {
      fill: "#f7d116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.05 16.505 15.539 16.152 16.028 16.505 15.841 15.933 16.33 15.579 15.726 15.579 15.539 15.007 15.352 15.579 14.748 15.579 15.237 15.933 15.05 16.505",
    style: {
      fill: "#f7d116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.67 18.578 15.483 18.006 15.296 18.578 14.692 18.578 15.181 18.932 14.994 19.504 15.483 19.151 15.972 19.504 15.785 18.932 16.274 18.578 15.67 18.578",
    style: {
      fill: "#f7d116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.778 13.425 11.267 13.07 11.756 13.425 11.569 12.85 12.058 12.495 11.454 12.495 11.267 11.92 11.08 12.495 10.476 12.495 10.965 12.85 10.778 13.425",
    style: {
      fill: "#f7d116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.457 21.497 11.27 20.922 11.083 21.497 10.479 21.497 10.968 21.852 10.781 22.427 11.27 22.072 11.759 22.427 11.572 21.852 12.061 21.497 11.457 21.497",
    style: {
      fill: "#f7d116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.138 14.282 8.627 13.927 9.116 14.282 8.929 13.707 9.418 13.352 8.814 13.352 8.627 12.777 8.44 13.352 7.836 13.352 8.325 13.707 8.138 14.282",
    style: {
      fill: "#f7d116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.092 20.642 13.905 20.067 13.718 20.642 13.114 20.642 13.603 20.997 13.416 21.572 13.905 21.217 14.394 21.572 14.207 20.997 14.696 20.642 14.092 20.642",
    style: {
      fill: "#f7d116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.339 14.216 13.828 13.861 14.317 14.216 14.13 13.641 14.619 13.286 14.015 13.286 13.828 12.711 13.641 13.286 13.037 13.286 13.526 13.641 13.339 14.216",
    style: {
      fill: "#f7d116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.906 20.71 8.719 20.135 8.532 20.71 7.928 20.71 8.417 21.065 8.23 21.64 8.719 21.285 9.208 21.64 9.021 21.065 9.51 20.71 8.906 20.71",
    style: {
      fill: "#f7d116"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/CV.5f3e984cd58d4126cffa9271ff307308.svg";
export { ForwardRef as ReactComponent };